import {Vue} from 'ui.vue';

import './BXmakerAuthuserphoneConsent.styl';

import './BXmakerAuthuserphoneButton';


/**
 * @emits onAgree {} (local) -  при нажатии на кнопку согласен
 * @emits onDisagree {} (local) -  при нажатии на кнопку не согласен
 * @emits onPopup {boolean} (local) -  изменение оторажения попап окна с соглашением
 */
Vue.component('BXmakerAuthuserphoneConsent',
    {
        props: {
            button: { //название кнопки, нажатие на которую является согласием
                type: String,
                default: ' - '
            },
            text: { // текст соглашения
                type: [String, Boolean],
                default: false
            },
            isReceived: { // флаг что согласие получено
                type: Boolean,
                default: false,
            }
        },
        data: function () {
            return {
                isShowPopup: false,
            };
        },
        computed: {
            localize() {
                return BX.Vue.getFilteredPhrases('BXMAKER_AUTHUSERPHONE_CORE_CONSENT_');
            },
            label() {
                return this.localize.BXMAKER_AUTHUSERPHONE_CORE_CONSENT_LABEL.replace(/#/, this.button)
            }
        },
        methods: {
            onAgree() {
                this.closePopup();
                this.$emit('onAgree')
            },
            onDisagree() {
                this.closePopup();
                this.$emit('onDisagree')
            },
            showPopup() {
                this.isShowPopup = true;
                document.body.classList.add("bxmaker-authuserphone-consent-popup-overflow-hidden");
                this.$emit('onPopup', true);
            },
            closePopup() {
                this.isShowPopup = false;
                document.body.classList.remove("bxmaker-authuserphone-consent-popup-overflow-hidden");
                this.$emit('onPopup', false);
            }
        },
        template: `
            <div class="bxmaker-authuserphone-consent">
                <label class="bxmaker-authuserphone-consent-button" @click.prevent.stop="showPopup">
                    <input type="checkbox" value="Y" name="consentReceived" :checked="isReceived"  />
                    <span>{{label}}</span>
                </label>
                <div class="bxmaker-authuserphone-consent-popup" v-if="isShowPopup">                   
                        <div class="bxmaker-authuserphone-consent-popup__container">
                            <div class="bxmaker-authuserphone-consent-popup__title">{{localize.BXMAKER_AUTHUSERPHONE_CORE_CONSENT_POPUP_TITLE}}</div>
                            <div class="bxmaker-authuserphone-consent-popup__text" v-html="text"></div>
                            <div class="bxmaker-authuserphone-consent-popup__action">
                                <BXmakerAuthuserphoneButton :white="true"  @onClick="onDisagree" :title="localize.BXMAKER_AUTHUSERPHONE_CORE_CONSENT_POPUP_BUTTON_DISAGREE" class="bxmaker-authuserphone-consent-popup__disagree" />
                                <BXmakerAuthuserphoneButton  @onClick="onAgree" :title="localize.BXMAKER_AUTHUSERPHONE_CORE_CONSENT_POPUP_BUTTON_AGREE" />
                            </div>
                        </div>
                </div>                 
            </div>
        `,
    });